/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Setpointtemperature1Inputs */



/**
* | output |
* | --- |
* | "Setpoint temperature" |
*
* @param {Br_History_Key_Setpointtemperature1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_setpointtemperature1 = /** @type {((inputs?: Br_History_Key_Setpointtemperature1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Setpointtemperature1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Setpoint temperature")
	return /** @type {LocalizedString} */ ("Température de consigne")
});
export { br_history_key_setpointtemperature1 as "br_history_key_setpointTemperature" }